import { render, staticRenderFns } from "./ConsultaProcessos.vue?vue&type=template&id=082437ca"
import script from "./ConsultaProcessos.vue?vue&type=script&lang=js"
export * from "./ConsultaProcessos.vue?vue&type=script&lang=js"
import style0 from "./ConsultaProcessos.vue?vue&type=style&index=0&id=082437ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports